import { render, staticRenderFns } from "./WriteGroundPost.vue?vue&type=template&id=4efc20f7&scoped=true&"
import script from "./WriteGroundPost.vue?vue&type=script&lang=js&"
export * from "./WriteGroundPost.vue?vue&type=script&lang=js&"
import style0 from "./WriteGroundPost.vue?vue&type=style&index=0&id=4efc20f7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4efc20f7",
  null
  
)

export default component.exports